/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_On_RecordInputs */



/**
* | output |
* | --- |
* | "NDA on record" |
*
* @param {Nda_On_RecordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_on_record = /** @type {((inputs?: Nda_On_RecordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_On_RecordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("NDA enregistré")
	if (locale === "es") return /** @type {LocalizedString} */ ("NDA registrado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("NDA registrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("NDA registrato")
	return /** @type {LocalizedString} */ ("NDA on record")
});